export const creepPreviewRoom = {
    room: 'PreviewRoom',
    // tslint:disable-next-line:max-line-length
    terrain: '1111111111111111111111111111111111111111111111111110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000022222020000000000000000000000000000011000000000000022202000000000000000000000000000000110000000000000000110000000000000000000000000000001100000000000000011100000000000000000000000000000011000000000000000111000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000110000000000000000000000000000000000000000000000001100000000000000000000000000000000000000000000000011000000000000000000000000000000000000000000000000111111111111111111111111111111111111111111111111111',
    type: 'terrain'
};

export const CREEP_PREVIEW_STATE = {
    objects: [{
        _id: '5ed771458a05f51fd087b05a',
        type: 'road',
        x: 16,
        y: 16,
        room: 'E25N18',
        notifyWhenAttacked: true,
        hits: 3600,
        hitsMax: 5000,
        nextDecayTime: 38073773,
        _updated: 13053921
    }, {
        _id: '5ed771458a05f51fd087b05b',
        type: 'road',
        x: 17,
        y: 15,
        room: 'E25N18',
        notifyWhenAttacked: true,
        hits: 3600,
        hitsMax: 5000,
        nextDecayTime: 38073773,
        _updated: 13053921
    }, {
        _id: '5ed771458a05f51fd087b05c',
        type: 'road',
        x: 18,
        y: 14,
        room: 'E25N18',
        notifyWhenAttacked: true,
        hits: 3600,
        hitsMax: 5000,
        nextDecayTime: 38073773,
        _updated: 13053921
    }, {
        _id: '5ed771458a05f51fd087b03c',
        type: 'road',
        x: 19,
        y: 13,
        room: 'E25N18',
        notifyWhenAttacked: true,
        hits: 3600,
        hitsMax: 5000,
        nextDecayTime: 38073773,
        _updated: 13053921
    }, {
        _id: '5ed771458a05f51fd087b05d',
        type: 'road',
        x: 15,
        y: 17,
        room: 'E25N18',
        notifyWhenAttacked: true,
        hits: 3600,
        hitsMax: 5000,
        nextDecayTime: 38073773,
        _updated: 13053921
    }, {
        _id: '5ed771458a05f51fd087b05e',
        type: 'road',
        x: 15,
        y: 18,
        room: 'E25N18',
        notifyWhenAttacked: true,
        hits: 3600,
        hitsMax: 5000,
        nextDecayTime: 38073773,
        _updated: 13053921
    }, {
        _id: '5ed771458a05f51fd087b01e',
        type: 'road',
        x: 15,
        y: 19,
        room: 'E25N18',
        notifyWhenAttacked: true,
        hits: 3600,
        hitsMax: 5000,
        nextDecayTime: 38073773,
        _updated: 13053921
    }, {
        _id: '5f2bf5cedbca7974eefa9b4d',
        name: '',
        x: 16,
        y: 16,
        body: [{
            type: 'work',
            hits: 100
        }, {
            type: 'carry',
            hits: 100
        }, {
            type: 'move',
            hits: 100
        }],
        store: {
            energy: 0
        },
        storeCapacity: 50,
        type: 'creep',
        room: 'W17N8',
        user: null,
        hits: 300,
        hitsMax: 300,
        spawning: false,
        fatigue: 0,
        notifyWhenAttacked: true,
        actionLog: {
            attacked: null,
            healed: null,
            attack: null,
            rangedAttack: null,
            rangedMassAttack: null,
            rangedHeal: null,
            harvest: null,
            heal: null,
            repair: null,
            build: null,
            say: null,
            upgradeController: null,
            reserveController: null
        },
        ageTime: 19512505
    }],
    users: {
        // '5a58af97d870324d18b43f02': {
        //     _id: '5a58af97d870324d18b43f02',
        //     username: 'Dmitriyff',
        //     badge: {
        //         type: 9,
        //         color1: '#770000',
        //         color2: '#000000',
        //         color3: '#000000',
        //         param: 0,
        //         flip: false,
        //         decoration: '5efe0a84afab0a4ab872313f'
        //     }
        // }
    }
};
